export default {
    init() {

    },
    finalize() {

        $(".gform_body input[value!=''], input[type='checkbox'], .gform_body textarea:not(:empty)").closest(".gfield").find(".gfield_label").addClass("d-block").removeClass("d-none");

        $(".ginput_container input, textarea").on("keyup", function() {
            if ($(this).val().length > 0) {
                $(this).closest(".gfield").find(".gfield_label").addClass("d-block").removeClass("d-none");
            } else {
                $(this).closest(".gfield").find(".gfield_label").removeClass("d-block").addClass("d-none");
            }
        });

        //
        // // $("#contact_modal_error").modal();
        //
        if($("div[id^='gform_confirmation_message']").length > 0 ){
            $("#contact_modal").modal();
        }
        $("#contact_modal").on('hide.bs.modal', function(){
            window.location.href = window.location.href;
        });
    },
};







// WEBPACK FOOTER //
// ./scripts/routes/custom-landing.js